"use strict";

/* eslint no-empty: 0 */
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFullScreen = exports.getTargetElement = void 0;
var react_1 = require("react");
var screenfull_1 = __importDefault(require("screenfull"));
var use_boolean_1 = __importDefault(require("./use-boolean"));
function getTargetElement(target, defaultElement) {
  if (!target) {
    return defaultElement;
  }
  var targetElement;
  if (typeof target === 'function') {
    targetElement = target();
  } else if ('current' in target) {
    targetElement = target.current;
  } else {
    targetElement = target;
  }
  return targetElement;
}
exports.getTargetElement = getTargetElement;
var useFullScreen = function (target, options) {
  var _a = options || {},
    onExitFull = _a.onExitFull,
    onFull = _a.onFull;
  var onExitFullRef = (0, react_1.useRef)(onExitFull);
  onExitFullRef.current = onExitFull;
  var onFullRef = (0, react_1.useRef)(onFull);
  onFullRef.current = onFull;
  var _b = __read((0, use_boolean_1.default)(false), 2),
    state = _b[0],
    _c = _b[1],
    toggle = _c.toggle,
    setTrue = _c.setTrue,
    setFalse = _c.setFalse;
  (0, react_1.useLayoutEffect)(function () {
    if (!state) {
      return;
    }
    var el = getTargetElement(target);
    if (!el && target) {
      return;
    }
    var onChange = function () {
      if (screenfull_1.default.isEnabled) {
        var isFullscreen = screenfull_1.default.isFullscreen;
        toggle(isFullscreen);
      }
    };
    if (screenfull_1.default.isEnabled) {
      try {
        if (target) {
          screenfull_1.default.request(el);
        } else {
          screenfull_1.default.request();
        }
        setTrue();
        if (onFullRef.current) {
          onFullRef.current();
        }
      } catch (error) {
        setFalse();
        if (onExitFullRef.current) {
          onExitFullRef.current();
        }
      }
      screenfull_1.default.on('change', onChange);
    }
    /* state 从 true 变为 false，则关闭全屏 */
    return function () {
      if (screenfull_1.default.isEnabled) {
        try {
          screenfull_1.default.off('change', onChange);
          screenfull_1.default.exit();
        } catch (error) {}
      }
      if (onExitFullRef.current) {
        onExitFullRef.current();
      }
    };
  }, [state, typeof target === 'function' ? undefined : target]);
  var toggleFull = function () {
    return toggle();
  };
  return [!!state, {
    setFull: setTrue,
    exitFull: setFalse,
    toggleFull: toggleFull
  }];
};
exports.useFullScreen = useFullScreen;
exports.default = exports.useFullScreen;